import { createContext, useContext, useState } from 'react'

const UserContext = createContext(undefined)

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const value = { user, setUser }

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}

const useUser = () => {
  const context = useContext(UserContext)
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider')
  }
  return context
}

export { UserProvider, useUser }
